import { JSX } from 'react';
import { ToggleListItem } from '@bg-components/Modals/TopSettingsModal/List/ToggleListItem';
import { useStore } from '@betgames/bg-state-manager';
import { t, playerSettingsSelectors, playerSettingsStore, playerSettingsApi } from '@bg-shared';

export const GuiOnlyAnimations = (): JSX.Element => {
    const animationsEnabled = useStore(
        playerSettingsStore,
        playerSettingsSelectors.getOnlyRngAnimationsEnabled,
    );

    return (
        <ToggleListItem
            label={t.string('animation')}
            enabled={animationsEnabled}
            dataQa="area-toggle-animation-list-item"
            onChange={(newValue) => {
                playerSettingsApi.update((store) => {
                    store.onlyRngAnimations = newValue;
                });
            }}
        />
    );
};
